import React from "react";
import { RFxMailLayout } from "./components/RFxMailLayout";
import { SubmissionDeadlineContentProps } from "./types/EmailContent.interface";
import { AdditionalMessageDisplay } from "./components/AdditionalMessageDisplay";
import { ButtonLink } from "./components/ButtonLink";

export const SubmissionDeadlineExtensionEmailContent: React.FC<
	SubmissionDeadlineContentProps
> = ({ isOnboarding, rfxMail, newDeadline }) => {
	const emailData = rfxMail?.emailData;

	if (!emailData) {
		return null;
	}

	const $additional_message = rfxMail.additional_message;
	const $owner_company_name = emailData.owner_company_name;

	return (
		<RFxMailLayout
			$supplier_contact_name={emailData.supplier_contact_name}
			$contact={emailData.contact}
			rfx_type={emailData.rfx_code}
			project_name={emailData.project_name}
			rfx_title={emailData.rfx_title}
			isOnboarding={isOnboarding}
		>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "20px",
					}}
				>
					We’d like to inform you that the deadline for the submission to{" "}
					{isOnboarding ? (
						<>
							the Onboarding and Pre-qualification request from{" "}
							<span className="bold">
								{$owner_company_name ?? "[RFx Creator Company Name]"}
							</span>{" "}
							on Procuracon
						</>
					) : (
						rfxMail.rfx_type_name_project_name()
					)}{" "}
					has been extended from the original deadline of{" "}
					{rfxMail.deadline_date_time(true)}.
					<br />
					<br />
					The new deadline for submission is:
					<br />
					<br />
					<div>
						<strong>
							{newDeadline ?? (
								<span className="italic">
									Please select a new date/time on the left to show it here
								</span>
							)}
						</strong>
					</div>
				</td>
			</tr>
			<AdditionalMessageDisplay additional_message={$additional_message} />
			<ButtonLink isOnboarding={isOnboarding} />
			<tr>
				<td
					className="pt-4"
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
					}}
				>
					We look forward to reviewing your submission by the new date.
				</td>
			</tr>
		</RFxMailLayout>
	);
};
